import boycottList from '../boycottList.json';
import { boycottListSection } from './types';

const getLists = ({ commit }: any) => {
  const lists = boycottList.lists.map(list => <boycottListSection>{
    section: list.section,
    index: list.list,
  });
  commit('addListsToStore', lists);
};

export default {
  getLists,
};
